import { useState } from 'react'
import * as API from '../../utility/api'
import moment from 'moment'

const ACTIONS = {
  TICKETS_OVERPAID: 'tickets_overpaid'
}

const Tools = () => {
  const [action, setAction] = useState(ACTIONS.TICKETS_OVERPAID)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [loadError, setLoadError] = useState(null)

  const fetchData = e => {
    e.preventDefault()

    setLoadError(null)
    setLoading(true)

    API.GET(`admin/tools/${action}`, {})
      .then(({ data }) => {
        setData(data)
        setLoadError(null)
        setLoading(false)
      })
      .catch(error => {
        console.error(error)
        setLoadError('Tietojen lataus epäonnistui.')
        setLoading(false)
      })
  }

  return (
    <div>
      <form className="admin-panel--raports--form-container" onSubmit={fetchData}>
        <div className="admin-panel--raports--form">
          <h3>Toiminto</h3>
          <label htmlFor="tickets-overpaid">
            <input
              id="tickets-overpaid"
              className="raport-radio"
              type="radio"
              checked={action === ACTIONS.TICKETS_OVERPAID}
              onChange={() => setAction(ACTIONS.TICKETS_OVERPAID)}
            />
            <span style={{ marginLeft: '5px' }}>
              Liput, joissa on liikaa maksuja
            </span>
          </label>

          <button disabled={loading} type="submit">
            {loading ? 'Ladataan....' : 'Lataa'}
          </button>
        </div>
      </form>
      {loadError && (
        <p className="raports-form-hint" role="alert">
          {loadError}
        </p>
      )}
      <ToolsResult data={data} setData={setData} />
    </div>
  )
}

const ToolsResult = ({ data, setData }) => {
  return toolsResultOverpaidTickets(data, setData)
}

const formatTimestamp = value => {
  if (!value) {
    return ''
  }

  const parsed = moment(new Date(value))
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : ''
}

const toolsResultOverpaidTickets = (data, setData) => {
  const toggleHandled = ticket => {
    const nextHandled = !Boolean(Number(ticket.handled) || ticket.handled)

    API.PUT('admin/tools/tickets_overpaid/handled', {
      order_product_id: ticket.order_product_id,
      handled: nextHandled
    })
      .then(({ data: result }) => {
        setData(previous => ({
          ...previous,
          tickets: previous.tickets.map(row =>
            row.order_product_id === ticket.order_product_id
              ? {
                  ...row,
                  handled: result.handled ? 1 : 0,
                  handled_at: result.handled
                    ? moment().format('YYYY-MM-DD HH:mm:ss')
                    : null
                }
              : row
          )
        }))
      })
      .catch(error => console.error(error))
  }

  const renderTicket = ticket => {
    const handled = Boolean(Number(ticket.handled) || ticket.handled)

    return (
      <tr
        key={ticket.order_product_id}
        className={handled ? 'tools-row--handled' : undefined}
        style={{ borderBottom: '1px solid #888888' }}
      >
        <td>
          <label>
            <input
              type="checkbox"
              aria-label={`Käsittelytila lipulle ${ticket.original_code}`}
              checked={handled}
              onChange={() => toggleHandled(ticket)}
            />
          </label>
        </td>
        <td>{ticket.original_code}</td>
        <td>
          {ticket.event_name}
          {ticket.event_start_date && (
            <>
              <br />
              <span className="raports-form-hint">
                {formatTimestamp(ticket.event_start_date)}
              </span>
            </>
          )}
        </td>
        <td>
          <a
            href={'https://pipetti.tiketti.fi/tilaus/' + ticket.tiketti_order_id}
            target="_blank"
            rel="noreferrer"
          >
            {ticket.tiketti_order_code}
          </a>
        </td>
        <td> {ticket.price / 100} €</td>
        <td>{ticket.transaction_id}</td>
        <td>{formatTimestamp(ticket.paytrail_payed_at)}</td>
        <td>
          {ticket.first_name} {ticket.last_name}
          <br />
          {ticket.email}
        </td>
        <td>{handled ? formatTimestamp(ticket.handled_at) || 'Käsitelty' : ''}</td>
      </tr>
    )
  }

  return (
    <div>
      <h2>Liput, joissa on liikaa maksuja</h2>
      {data && data.tickets.length === 0 && (
        <div>Ei löytynyt lippuja, joissa olisi liikaa maksuja.</div>
      )}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Käsitelty</th>
            <th>Lippukoodi</th>
            <th>Tapahtuma</th>
            <th>Pipetti Tilaus</th>
            <th>Hinta (€)</th>
            <th>Transaktio ID</th>
            <th>Maksettu</th>
            <th>Asiakas</th>
            <th>Käsitelty</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.tickets &&
            data.tickets.map(ticket => renderTicket(ticket))}
        </tbody>
      </table>
    </div>
  )
}

export default Tools
